/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum OrganisationPermissionType {
  GetOrganisation = 1,
  UpdateOrganisation = 10,
  DeleteOrganisation = 20,
  CreateSubscription = 30,
  UpdateSubscription = 40,
  UpdateSubscriptionPayment = 41,
  CreateRole = 50,
  UpdateRole = 60,
  DeleteRole = 70,
  UpdateAdministrator = 80,
  TransferOwnership = 90,
  CreateInvitation = 100,
  DeleteInvitation = 110,
  GetUser = 120,
  ListUsers = 130,
  UpdateUser = 140,
  DeleteUser = 150,
  ListRegisters = 160,
  CreateRegister = 170,
  DeleteRegister = 180,
  UpdateRegisterUser = 190,
  CreateOrganisationBulkAction = 200,
  UpdateOrganisationBulkAction = 210,
  RollbackOrganisationBulkAction = 220,
  DeleteOrganisationBulkAction = 230,
  CreateTag = 240,
  UpdateTag = 250,
  DeleteTag = 260,
  ImportUsersFromOrganisation = 270,
  CreateCustomReportTemplates = 280,
  ViewReportTemplates = 290,
}
